import { call, put } from "redux-saga/effects";
import {
  addPhysicalInventory,
  addOtcProduct,
  addRxProduct,
  addOtcManualProduct,
  addPhysicalInventoryOtcRxProduct,
  addPhysicalInventoryManualRx,
  addPhysicalInventoryOtcRxProductWithoutLotNo,
  addPhysicalInventoryWithoutLotNo,
} from "../../app/components/InventoryManagement/PhysicalInventory/helper/physicalInventoryHelper";
import {
  addPhysicalInventorySuccessAction,
  addOtcProductSuccessAction,
  addRxProductSuccessAction,
  addOtcManualProductSuccessAction,
  addPhysicalInventoryManualRxSuccessAction,
} from "./actions";

export function* addPhysicalInventorySaga(payload) {
  try {
    const response = yield call(
      addPhysicalInventory,
      payload.physicalInventoryData
    );
    yield put(addPhysicalInventorySuccessAction(response));
  } catch (err) {}
}

export function* addPhysicalInventoryManualRxSaga(payload) {
  try {
    const response = yield call(
      addPhysicalInventoryManualRx,
      payload.physicalInventoryData
    );
    yield put(addPhysicalInventoryManualRxSuccessAction(response));
  } catch (err) {}
}

export function* addPhysicalInventoryManualRxWithoutLotNoSaga(payload) {
  try {
    const response = yield call(
      addPhysicalInventoryWithoutLotNo,
      payload.physicalInventoryData
    );
    yield put(addPhysicalInventoryManualRxSuccessAction(response));
  } catch (err) {}
}

export function* addPhysicalInventoryOtcRxProductSaga(payload) {
  try {
    const response = yield call(
      addPhysicalInventoryOtcRxProduct,
      payload.addOtcProductData
    );
    yield put(addPhysicalInventorySuccessAction(response));
  } catch (err) {}
}

export function* addPhysicalInventoryOtcRxProductWithoutLotNoSaga(payload) {
  try {
    const response = yield call(
      addPhysicalInventoryOtcRxProductWithoutLotNo,
      payload.addOtcProductData
    );
    yield put(addPhysicalInventorySuccessAction(response));
  } catch (err) {}
}

export function* addOtcProductSaga(payload) {
  try {
    const response = yield call(addOtcProduct, payload.addOtcProductData);
    yield put(addOtcProductSuccessAction(response));
  } catch (err) {}
}

export function* addRxProductSaga(payload) {
  try {
    const response = yield call(addRxProduct, payload.addRxProductData);
    yield put(addRxProductSuccessAction(response));
  } catch (err) {}
}

export function* addOtcManualProductSaga(payload) {
  try {
    const response = yield call(
      addOtcManualProduct,
      payload.addOtcManualProductData
    );
    yield put(addOtcManualProductSuccessAction(response));
  } catch (err) {}
}
